import {scrollToSection} from './scrollHelper';

const onScrollComplete = async ({element, func, tabName, navMargin, runCount}) => {
    // after page scrolls to new position,
    // verify that the target section is in fact in view as expected
    // as content could have shifted due to lazy loading
    // only allow re-scroll to occur once to prevent ping-ponging
    const topPosition = element.getClientRects()['0'].top;
    const isInTopHalfOfViewport = topPosition >= navMargin && topPosition <= window.innerHeight / 2;

    if (!isInTopHalfOfViewport && runCount < 1) {
        func(tabName, 500, runCount + 1);
    }
};

function scrollToNavTab(tabName, duration = 500, runCount = 0, extraPush = 2) {
    const element = window.document.querySelector(`#${tabName}`);
    const elementRect = element.getClientRects();
    const elementTop = elementRect['0'].top;
    const navBar = window.document.querySelector('.listing-page__nav');
    if (navBar) {
        const navBarRect = navBar.getClientRects();
        const navHeight = navBarRect['0'].height;
        const navMargin = navHeight - extraPush;
        const change = elementTop - navMargin;

        scrollToSection(change, duration, onScrollComplete, {
            element,
            func: scrollToNavTab,
            tabName,
            navMargin,
            runCount
        });
    } else {
        const navigationBarHeight = 50;
        const change = elementTop - navigationBarHeight;
        scrollToSection(change, duration, null, {element});
    }
}

export default scrollToNavTab;
export {scrollToNavTab, onScrollComplete};
